module.exports = require('promise/lib/es6-extensions')



//////////////////
// WEBPACK FOOTER
// ./~/universal-promise/promise.js
// module id = 766
// module chunks = 0